export default __webpack_public_path__ + "static/media/jaipur.bb40abf1.png";